import React from 'react';
import Control from 'components/molecules/input-control';
import { useAuth } from 'providers/auth';
import { Progress, Button, Icon } from "semantic-ui-react";
import { validateEmail, checkPasswordStrength } from "utils/functions";
import { toast } from 'providers/ui';
import getConfig from 'next/config';

import css from './styles.module.scss';

const { publicRuntimeConfig } = getConfig();

export default function SignUp(props) {

  const { onCancel } = props;

  const [valid, setValid] = React.useState(false);
  const [showPwd, setShowPwd] = React.useState(false);
  const [registering, setRegistering] = React.useState(false);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordConfirm, setPasswordConfirm] = React.useState("");
  const [pwdStrength, setPwdStrength] = React.useState("invalid");
  const [alternativeContent, setAlternativeContent] = React.useState("");

  const {
    signUpWithEmail
  } = useAuth();

  function checkEmailConstraints (email) {
    if (publicRuntimeConfig.DISABLE_REGISTRATION) {
      return false;
    }

    const contraints = publicRuntimeConfig.REGISTRATION_CONSTRAINT || "*";

    if (contraints?.toUpperCase() === 'NONE') {
      return false;
    }

    if (contraints !== '*' && contraints.toUpperCase() !== 'ANY') {
      const validDomains = contraints.replace(/[,;]/g, '|');

      if (!email.match(new RegExp(`@(${validDomains})$`))) {
        return false;
      }
    }

    return true;
  }

  function checkName (name) {
    return name.length > 3;
  }

  function checkPasswords (password, passwordConfirm) {
    if (password.length < 8) {
      return false;
    }

    if (password !== passwordConfirm) {
      return false;
    }

    if (pwdStrength === 'medium' || pwdStrength === 'strong') {
      return true;
    }

    return false;
  }

  React.useEffect(_ => {
    const pwdStrength = checkPasswordStrength(password);
    setPwdStrength(pwdStrength);

    if (
      checkName(name) &&
      validateEmail(email) &&
      checkPasswords(password, passwordConfirm) &&
      checkEmailConstraints(email)
    ) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [name, email, password, passwordConfirm]);

  async function signUpWithEmailForm() {

    if (!valid) { return; }

    setRegistering(true);
    const { data, error } = await signUpWithEmail(
      email,
      password,
      { firstName: name }
    );

    if (error) {
      toast.error("Failed registering! " + error.message, {
        position: toast.POSITION.TOP_CENTER,
        // autoClose: false,
        closeButton: true
      });
      setRegistering(false);
    } else {
      const userMail = data.user.email;
      const domain = 'https://' + userMail.split('@')[1];
      setAlternativeContent(<>
        An e-mail was sent to<br />
        <a href={domain} className={css['email-link']}>{userMail}</a>
        with a verification link.<br />
        You may close this tab now.<br />
      </>);
      setRegistering(false);
    }
  }

  function getEmailConstraintsHelperText () {
    const contraint = publicRuntimeConfig.REGISTRATION_CONSTRAINT || "*";
    if (contraint === '*' || contraint.toUpperCase() === 'ANY') {
      return null;
    }

    return `@${contraint.split(/[,;]/g).join(`, @`)}`;
  }

  function getPwdStrength() {
    switch (pwdStrength) {
    case 'strong':
      return { color: 'green', perc: 100 };
    case 'medium':
      return { color: 'yellow', perc: 65 };
    case 'weak':
      return { color: 'orange', perc: 35 };

    default:
      return { color: 'red', perc: 5 };
    }
  }
  const pwdStrUI = getPwdStrength(password);

  return (
    <div className={css['create-account-form-container']}>
      {alternativeContent}
      {
        !alternativeContent && <>
          <div className={css['block']}>
            <Control
              // fluid
              type="text"
              // label={'E-mail'}
              placeholder="Full name"
              disabled={!!registering}
              // label="Name"
              // disabled={loadingAddr}
              // size='mini'
              // asObject
              style={{width: '195px'}}
              onChange={event => setName(event.target.value)}
              value={name}
              width={2}
              // disabled={!!registering || !!reseting}
            />
            <Control
              // fluid
              type="email"
              // label={'E-mail'}
              placeholder="E-mail"
              helperText={getEmailConstraintsHelperText}
              style={{width: '195px'}}
              disabled={!!registering}
              // label="E-mail"
              // disabled={loadingAddr}
              // size='mini'
              // asObject
              onChange={event => setEmail(event.target.value)}
              value={email}
              width={2}
              // disabled={!!registering || !!reseting}
            />
          </div>

          <div>
            Password
            <div className={css['pwd-disclaimer']}>
              Minimum of 8 characters including Upper and Lower case,
              numbers and symbols
            </div>
          </div>
          <div className={css['block']}>
            <div>
              <Control
                type={showPwd ? "text" : "password"}
                placeholder={'Password'}
                // fluid
                onChange={event => setPassword(event.target.value)}
                value={password || ""}
                disabled={!!registering}
                icon={{
                  name: 'eye' + (showPwd ? '' : ' slash'),
                  size: 'small',
                  link: true,
                  onClick: () => {
                    setShowPwd(!showPwd);
                  }
                }}
                // disabled={loadingAddr}
                // size='mini'
                // asObject
                // onChange={onIptChange}
                // value={formValues?.state}
                width={2}
                // disabled={!!registering || !!reseting}
              />

              <Progress
                percent={pwdStrUI.perc}
                inverted
                color={pwdStrUI.color}
                // progress
                attached='top'
              />
            </div>

            <Control
              // fluid
              type={showPwd ? "text" : "password"}
              placeholder={'Confirm password'}
              onChange={event => setPasswordConfirm(event.target.value)}
              value={passwordConfirm}
              disabled={!!registering}
              // fluid
              icon={{
                name: 'eye' + (showPwd ? '' : ' slash'),
                size: 'small',
                link: true,
                onClick: () => {
                  setShowPwd(!showPwd);
                }
              }}
              // disabled={loadingAddr}
              // size='mini'
              // asObject
              // onChange={onIptChange}
              // value={formValues?.state}
              width={2}
              // disabled={!!registering || !!reseting}
            />
          </div>
          <Button
            // size="large"
            // fluid
            color="green"
            disabled={!valid}
            loading={!!registering}
            style={{
              whiteSpace: 'nowrap',
              width: '150px',
              margin: '2rem auto'
            }}
            onClick={(_) => {
              signUpWithEmailForm();
              // if (location) location.href = '/api/auth/login';
            }}
          >
            <Icon name="check" />
            Register
          </Button>

          <div className={css['sign-in-instead']}>
            Already have an account?&nbsp;
            <Button
              // color='green'
              className={css['sign-in-button']}
              basic
              disabled={!!registering}
              // loading={!!registering}
              onClick={(_) => {
                onCancel();
              }}
            >
              Sign in
            </Button>
          </div>
        </>
      }
    </div>
  );
}
